<template>
    <div class="day-timeline-body">
        <v-overlay :model-value="loading" contained persistent
                   class="align-center justify-center">
            <v-progress-circular color="primary"
                                 indeterminate
                                 size="64"></v-progress-circular>
        </v-overlay>
        <div v-if="data" class="w-100 overflow-x-auto h-100">
            <day-line-timeline v-for="(header, index) in ['Line 1', 'Line 2']" :key="header" :line-data="data[index]" :header="header" class="timeline-line"></day-line-timeline>
        </div>
    </div>
</template>
<style scoped>
    .day-timeline-body {
        width: 100%;
        height: 100%;
        padding: 5px;
        position: relative;
    }
    .timeline-line {
        border-bottom:1px solid grey;
    }
</style>
<script>
    import { mapActions, mapState, mapMutations } from "vuex";
    function initialState() {
        return {
            loading: false,
            data: []
        };
    }
    export default {
        name: "DayTimeline",
        data: function () {
            return initialState();
        },
        mounted: function () {
        },
        props: {
            openView: Boolean,
        },
        methods: {
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack"
            ]),
            loadData() {
                this.loading = true;
                this.$api.get('/dashboard/timelineprogress')
                    .then(res => {
                        this.loading = false;
                        this.data = res.data;
                    }).catch(error => {
                        this.loading = false;
                        this.showErrorSnack("There was an issue getting the data");
                    });
            }
        },
        computed: {
        },
        watch: {
            openView: {
                handler() {
                    if (this.openView) {
                        this.loadData();
                    }
                }
            }
        }
    };
</script>
